import { asyncStart } from '../../../common';

export const GET_CAMPUS_GROUPS = 'CampusGroups.getCampusGroups';
export const getCampusGroups = () => (dispatch) => {
  dispatch(asyncStart(GET_CAMPUS_GROUPS));
  dispatch({ type: GET_CAMPUS_GROUPS });
};

export const SAVE_CAMPUS_GROUP = 'CampusGroups.saveCampusGroup';
export const saveCampusGroup = (data) => (dispatch) => {
  dispatch(asyncStart(SAVE_CAMPUS_GROUP));
  dispatch({
    type: SAVE_CAMPUS_GROUP,
    data,
  });
};

export const DELETE_CAMPUS_GROUP = 'CampusGroups.deleteCampusGroup';
export const deleteCampusGroup = (data) => (dispatch) => {
  dispatch(asyncStart(DELETE_CAMPUS_GROUP));
  dispatch({
    type: DELETE_CAMPUS_GROUP,
    data,
  });
};
